import React from "react";

import ReactOnRails from "Utils/ReactOnRails";

import { Card } from "Common/Card";
import Header from "Common/Header";
import Icon from "Common/Icon";
import { Table } from "Common/Table";

export default class BrokerBenefitsComparisonTable extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Card>
        <Table striped={false} compact={false} borders="all" mt={0}>
          <thead>
            <tr>
              <th style={{ width: "20%" }}>&nbsp;</th>
              <th style={{ width: "40%" }}>
                <img alt="SimplyInsured" className="ResponsiveTopBar__Logo" style={{ height: "30px" }} src="/assets/simplyinsured-logo-headercolor.png" />
              </th>
              <th style={{ width: "40%" }}>
                <Header level={1}>Traditional Broker</Header>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={{ width: "20%", textAlign: "center" }}>Plan Premiums</td>
              <td style={{ width: "40%" }}>
                <span style={{ display: "flex" }}>
                  <Icon icon="check" size="2x" mr={3} style={{ color: "green", textAlign: "center" }} />

                  <span>Never different, price set by law</span>
                </span>
              </td>
              <td style={{ width: "40%" }}>
                <span style={{ display: "flex" }}>
                  <Icon icon="check" size="2x" mr={3} style={{ color: "green", textAlign: "center" }} />

                  <span>Never different, price set by law</span>
                </span>
              </td>
            </tr>
            <tr>
              <td style={{ width: "20%", textAlign: "center" }}>Costs</td>
              <td style={{ width: "40%" }}>
                <span style={{ display: "flex" }}>
                  <Icon icon="check" size="2x" mr={3} style={{ color: "green", textAlign: "center" }} />

                  <span>No Cost</span>
                </span>
              </td>
              <td style={{ width: "40%" }}>
                <span style={{ display: "flex" }}>
                  <Icon icon="check" size="2x" mr={3} style={{ color: "green", textAlign: "center" }} />

                  <span>No Cost</span>
                </span>
              </td>
            </tr>
            <tr>
              <td style={{ width: "20%", textAlign: "center" }}>Payroll Integration</td>
              <td style={{ width: "40%" }}>
                <span style={{ display: "flex" }}>
                  <Icon icon="check" size="2x" mr={3} style={{ color: "green", textAlign: "center" }} />

                  <span>Fully integrated deductions with Intuit QuickBooks and Square Payroll. Easy setup for ADP, Paychex, etc.</span>
                </span>
              </td>
              <td style={{ width: "40%" }}>
                <span style={{ display: "flex" }}>
                  <Icon
                    icon="times"
                    size="2x"
                    mr={3}
                    style={{
                      color: "#c62828",
                      textAlign: "center",
                      minWidth: "28px",
                    }}
                  />

                  <span>Some help calculating deductions by yourself</span>
                </span>
              </td>
            </tr>
            <tr>
              <td style={{ width: "20%", textAlign: "center" }}>Renewals</td>
              <td style={{ width: "40%" }}>
                <span style={{ display: "flex" }}>
                  <Icon icon="check" size="2x" mr={3} style={{ color: "green", textAlign: "center" }} />

                  <span>1 click renewals, online open enrollment with no headaches</span>
                </span>
              </td>
              <td style={{ width: "40%" }}>
                <span style={{ display: "flex" }}>
                  <Icon
                    icon="times"
                    size="2x"
                    mr={3}
                    style={{
                      color: "#c62828",
                      textAlign: "center",
                      minWidth: "28px",
                    }}
                  />

                  <span>Re-fill, re-sign, and re-fax new forms every year</span>
                </span>
              </td>
            </tr>
            <tr>
              <td style={{ width: "20%", textAlign: "center" }}>Support</td>
              <td style={{ width: "40%" }}>
                <span style={{ display: "flex" }}>
                  <Icon icon="check" size="2x" mr={3} style={{ color: "green", textAlign: "center" }} />

                  <span>Team of licensed experts to answer all of your questions</span>
                </span>
              </td>
              <td style={{ width: "40%" }}>
                <span style={{ display: "flex" }}>
                  <Icon
                    icon="times"
                    size="2x"
                    mr={3}
                    style={{
                      color: "#c62828",
                      textAlign: "center",
                      minWidth: "28px",
                    }}
                  />

                  <span>Limited support, contact insurance carriers directly for help</span>
                </span>
              </td>
            </tr>
            <tr>
              <td style={{ width: "20%", textAlign: "center" }}>Plans</td>
              <td style={{ width: "40%" }}>
                <span style={{ display: "flex" }}>
                  <Icon icon="check" size="2x" mr={3} style={{ color: "green", textAlign: "center" }} />

                  <span>Every available plan, every available carrier</span>
                </span>
              </td>
              <td style={{ width: "40%" }}>
                <span style={{ display: "flex" }}>
                  <Icon
                    icon="times"
                    size="2x"
                    mr={3}
                    style={{
                      color: "#c62828",
                      textAlign: "center",
                      minWidth: "28px",
                    }}
                  />

                  <span>Only carriers they work with</span>
                </span>
              </td>
            </tr>
            <tr>
              <td style={{ width: "20%", textAlign: "center" }}>Employee Onboarding</td>
              <td style={{ width: "40%" }}>
                <span style={{ display: "flex" }}>
                  <Icon icon="check" size="2x" mr={3} style={{ color: "green", textAlign: "center" }} />

                  <span>Online onboarding in minutes, new hires benefits all in one place</span>
                </span>
              </td>
              <td style={{ width: "40%" }}>
                <span style={{ display: "flex" }}>
                  <Icon
                    icon="times"
                    size="2x"
                    mr={3}
                    style={{
                      color: "#c62828",
                      textAlign: "center",
                      minWidth: "28px",
                    }}
                  />

                  <span>Manually onboard with paper forms and wait weeks for processing</span>
                </span>
              </td>
            </tr>
          </tbody>
        </Table>
      </Card>
    );
  }
}

ReactOnRails.register({ BrokerBenefitsComparisonTable }, module);
